module.exports = __webpack_public_path__ + "static/media/dufry.9ff7f9a0.png";